import { fetcher } from './fetcher';

export default (searchParams: URLSearchParams) =>
  fetcher('/?' + searchParams.toString()).catch(console.error);
